export function amountize(amount: number, singular: string, plural?: string) {
  let text = singular;
  if (amount !== 1) {
    text = plural || `${singular}n`;
  }
  return `${amount} ${text}`;
}
